import { Selector } from '@ngxs/store';
import { PresenceDurationBrickSettingRemoteDto } from 'src/generated/swagger';
import { PresenceDurationBrickSettingsState, PresenceDurationBrickSettingsStateModel } from './presence-duration-brick-settings.state';

export class PresenceDurationBrickSettingsStateSelectors {
   @Selector([PresenceDurationBrickSettingsState, PresenceDurationBrickSettingsState.getSettingModelFn])
   public static getIsProgressbarShown(
      state: PresenceDurationBrickSettingsStateModel,
      getSettingModelFn: (state, brickInstanceId) => PresenceDurationBrickSettingRemoteDto
   ) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showProgressbar;
      };
   }

   @Selector([PresenceDurationBrickSettingsState, PresenceDurationBrickSettingsState.getSettingModelFn])
   public static getIsTextShown(
      state: PresenceDurationBrickSettingsStateModel,
      getSettingModelFn: (state, brickInstanceId) => PresenceDurationBrickSettingRemoteDto
   ) {
      return (brickId: string) => {
         return getSettingModelFn(state, brickId).showDurationAsText;
      };
   }
}
